// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { creditCardDetailsEntryStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/CreditCardDetailsEntry";
import { getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { checkoutReviewAndSubmitPaymentDetailsStyles as styles } from "@monsma/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPaymentDetails";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

export const leftColSpace = css`
    padding-right: 40px;
    ${screen("lte", "md")} {
        padding-right: 15px;
    }
`;

export const rightColSpace = css`
    padding-left: 40px;
    ${screen("lte", "md")} {
        padding-left: 15px;
    }
`;

styles.paymentMethodAndPONumberContainer = {
    gap: 30,
};

styles.paymentMethodGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        ${leftColSpace}
    `,
};
styles.poNumberGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        ${rightColSpace}
    `,
};

styles.creditCardDetailsGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        border-top: 1px solid ${getColor("common.ui12")};
        margin-top: 20px;
        padding-top: 30px;
        ${leftColSpace};
    `,
};

styles.creditCardAddressGridItem = {
    width: [12, 12, 12, 6, 6],
    css: css`
        flex-direction: column;
        border-top: 1px solid ${getColor("common.ui12")};
        margin-top: 20px;
        padding-top: 30px;
        ${rightColSpace};
    `,
};

styles.paymentProfileExpiredErrorWrapper = {
    css: css`
        display: flex;
        ${screen("gt", "md")} {
            margin-left: -20px;
            width: calc(100% + 25px);
        }
    `,
};

styles.paymentProfileEditCardLink = {
    css: css`
        ${getProp("theme.link.defaultProps.css")};
        margin-left: 15px;
        white-space: nowrap;
    `,
};

styles.xStyle = {
    customerReference: {
        cssOverrides: {
            formField: css`
                margin-top: 20px;
            `,
        },
    },
    weAcceptWrapper: {
        css: css`
            padding-top: 10px;
        `,
    },
    weAcceptTitle: {
        css: css`
            margin: 10px 0;
        `,
    },
    weAcceptIconsWrapper: {
        css: css`
            display: flex;
        `,
    },
    weAcceptIcon: {
        color: "common.ui10",
        size: 36,
        css: css`
            margin-right: 15px;
            opacity: 0.4;
            transition: 300ms opacity ease;
            ${({ isActive }: any) =>
                isActive &&
                css`
                    opacity: 1;
                `};
        `,
    },
};

creditCardDetailsEntryStyles.cardTypeGridItem = {
    css: css`
        display: none;
    `,
};
